import { Link } from '@tanstack/react-router';
import { Button } from '../ui/button';
import { ShieldX } from '../../icons';

export function UnauthorizedPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background text-foreground">
      <ShieldX size={48} className="text-muted-foreground" />
      <h1 className="text-heading-h5">Access denied</h1>
      <p className="max-w-xs text-center text-body-sm-regular text-muted-foreground">
        You don&apos;t have permission to view this page.
      </p>
      <Button asChild variant="outline">
        <Link to="/">Go home</Link>
      </Button>
    </div>
  );
}
